import { useState } from "react";

import GuideVideoModal from "./index";
import { guideVideoData } from "./data";

const STORAGE_KEY = "guideModal_doNotShow";

const getDoNotShowMap = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

const setDoNotShowForKey = (pageKey) => {
  const map = getDoNotShowMap();
  map[pageKey] = true;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
};

const GuideVideoModalController = ({ pageKey }) => {
  const modalData = guideVideoData.find((d) => d.key === pageKey);

  const [hidden, setHidden] = useState(() => !!getDoNotShowMap()[pageKey]);
  const [doNotShow, setDoNotShow] = useState(false);

  if (!modalData || hidden) return null;

  const handleDoNotShow = (checked) => {
    setDoNotShow(checked);
  };

  const handleClose = () => {
    if (doNotShow) {
      setDoNotShowForKey(pageKey);
    }
    setHidden(true);
  };

  return (
    <GuideVideoModal
      {...modalData}
      hidden={false}
      onDoNotShow={handleDoNotShow}
      onClose={handleClose}
    />
  );
};

export default GuideVideoModalController;
